import { jsx, jsxs } from "react/jsx-runtime";
import { ContentfulImgOptimizer } from "../ContentfulImgOptimizer/ContentfulImgOptimizer.js";
import { Image } from "../Image/index.js";
import { P } from "../Text/P.js";
import { logoConfig, logoImgLabelRowVariants, logoImgLabelTextStyleBySize, logoImgVariants } from "./LogoImg.variants.js";
function LogoImg({ src, alt, text, size = 'md', emphasis = 'regular', display = 'inline', clearSpace = false, colorMode = 'original', className, lazyLoad, lazyRootMargin, lazyForceLoad, showSkeletonWhileLoading }) {
    const sizeKey = size ?? 'md';
    const sizeConfig = logoConfig[sizeKey];
    const { wrapper, img } = logoImgVariants({
        size,
        emphasis,
        display,
        clearSpace,
        colorMode
    });
    const hasText = null != text && '' !== text;
    const wrapperStyle = {
        ...clearSpace ? {
            padding: sizeConfig.clearSpace
        } : {},
        ...hasText ? {} : {
            maxWidth: sizeConfig.maxWidth
        }
    };
    const labelTextStyle = logoImgLabelTextStyleBySize[sizeKey];
    const labelShade = 'bold' === emphasis ? '1' : '13';
    const sharedImageProps = {
        alt,
        isSvg: true,
        height: sizeConfig.height,
        className: img(),
        lazyLoad,
        lazyRootMargin,
        lazyForceLoad,
        showSkeletonWhileLoading
    };
    const image = 'object' == typeof src && 'contentfulUrl' in src ? /*#__PURE__*/ jsx(ContentfulImgOptimizer, {
        contentfulUrl: src.contentfulUrl,
        ...sharedImageProps
    }) : /*#__PURE__*/ jsx(Image, {
        src: src,
        ...sharedImageProps
    });
    return /*#__PURE__*/ jsx("div", {
        className: wrapper({
            className
        }),
        style: wrapperStyle,
        children: hasText ? /*#__PURE__*/ jsxs("div", {
            className: logoImgLabelRowVariants({
                size: sizeKey,
                display
            }),
            children: [
                /*#__PURE__*/ jsx(P, {
                    textStyle: labelTextStyle,
                    palette: "neutral",
                    shade: labelShade,
                    className: "m-0 shrink-0",
                    children: text
                }),
                /*#__PURE__*/ jsx("div", {
                    className: "inline-flex shrink-0",
                    style: {
                        maxWidth: sizeConfig.maxWidth
                    },
                    children: image
                })
            ]
        }) : image
    });
}
export { LogoImg };
